import { Component } from 'react'
import { formatAmountDelta } from 'helpers/formatHelpers'
import Section from 'components/features/pfm/NetworthSummarySection/NetworthSummarySection'
import * as styles from 'components/features/pfm/NetworthDelta/NetworthDelta.css'

export type NetworthDeltaStateProps = {
  title: string
  value: string
}

export type NetworthDeltaDispatchProps = {
  onClick: () => void
}

export type NetworthDeltaProps = NetworthDeltaDispatchProps & NetworthDeltaStateProps

class NetworthDelta extends Component<NetworthDeltaProps> {
  render () {
    const {
      title,
      value,
      onClick,
    } = this.props
    const className = Number(value) < 0
      ? styles.negativeDelta
      : styles.positiveDelta

    return (
      <Section title={ title } onClick={ onClick }>
        <span className={ className }>
          { formatAmountDelta(value) }
        </span>
      </Section>
    )
  }

}

export default NetworthDelta
